import { render, staticRenderFns } from "./PurchaseListFooter.vue?vue&type=template&id=3b7eb64a&"
import script from "./PurchaseListFooter.vue?vue&type=script&lang=js&"
export * from "./PurchaseListFooter.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseListFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports